import Button from '../../general/button/button';
import styles from './session-invalidation-alert-modal.module.scss';
import {
  sessionInvalidationTypes,
  genericLokaliseKey,
  typesMappedToLokaliseKeys,
} from './constants';
import type {
  SessionInvalidationTypes,
  SessionInvalidationData,
} from './types';

type Props = {
  onClose: () => void;
  payload: {
    type: SessionInvalidationTypes;
    data?: SessionInvalidationData;
  };
};

export const SessionInvalidationAlertModal = ({ onClose, payload }: Props) => {
  let value;

  if (
    payload.type === sessionInvalidationTypes.sessionTimeout &&
    payload.data
  ) {
    value = {
      timeout: polyglot.t(
        `components.${
          typesMappedToLokaliseKeys[sessionInvalidationTypes.sessionTimeout]
        }_alert_modal.${payload.data.unit}`,
        // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
        parseInt(payload.data.amount),
      ),
    };
  }

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>
        {polyglot.t(`components.${genericLokaliseKey}_alert_modal.title`)}
      </h1>
      <p className={styles.subtitle}>
        {polyglot.t(
          `components.${
            typesMappedToLokaliseKeys[payload.type]
          }_alert_modal.subtitle`,
          value,
        )}
      </p>
      <div className={styles.button}>
        <Button
          dataHook='session-invalidation-got-it-button'
          text={polyglot.t(
            `components.${genericLokaliseKey}_alert_modal.got_it`,
          )}
          onClick={onClose}
        />
      </div>
    </div>
  );
};

SessionInvalidationAlertModal.displayName = 'SessionInvalidationAlertModal';

export default SessionInvalidationAlertModal;
